import { VerticalTimelineElement } from "react-vertical-timeline-component";
import { TimelineElementProps } from "./types";
import { COMPETITION_TYPES } from "./winners-constants";
import UnPublishedWinner from "./unpublished-winners";
import PublishedWinner from "./published-winners";
import { useInView } from "react-intersection-observer";
import React, { useContext } from "react";
import { CurrentPageContext } from "./winners-context";

const TimelineElement = ({ index, winner, playedWinnerPosition, setPlayedWinnerPosition }: TimelineElementProps) => {
  const isWinnersPage = useContext(CurrentPageContext);
  const { ref, inView } = useInView({
    triggerOnce: true,
  });

  const isEven = index % 2 === 0;
  const baseOrder = isEven ? "lg:pr-[3.7rem]" : "lg:pl-[3.7rem]";

  const adServerOrder = index === 0 ? baseOrder : isEven ? "lg:pl-[3.7rem]" : "lg:pr-[3.7rem]";

  return (
    <div data-index={index} ref={ref} className="vertical-timeline-element">
      <VerticalTimelineElement
        date={isWinnersPage ? winner.Date?.MY : `${winner.PickupDate.MonthDate} ${winner.PickupDate.Year}`}
        visible={inView}>
        <div className={`grid text-center justify-center items-center md:px-0 ${baseOrder}`}>
          {isWinnersPage ? (
            <>
              {winner.SuppressResults === "True" && COMPETITION_TYPES.includes(winner.CompType) && (
                <UnPublishedWinner
                  placeholderWinnerImageUrl={winner.PlaceholderWinnerImageUrl}
                  competitionType={winner.CompType}
                  position={index}
                />
              )}
              {winner.SuppressResults === "False" && (
                <PublishedWinner
                  playedWinnerVideoPosition={playedWinnerPosition}
                  position={index}
                  setPlayedWinnerPosition={setPlayedWinnerPosition}
                  winnerName={winner.Name}
                  winnerPhoto={winner.Photo}
                  winnerMobilePhoto={winner.MobilePhoto}
                  winnerVideo={winner.Video}
                  competitionDateRange={winner.CompetitionDateRange}
                  competitionPictureTitle={winner.CompetitionPictureTitle}
                  competitionType={winner.CompType}
                  prize={winner.Prize}
                  numberOfInstantWins={winner.NumberOfInstantWins}
                  winnerDetailsLink={winner.Url}
                  isInstantWinCompetition={winner.isInstantWinCompetition}
                />
              )}
            </>
          ) : (
            <>
              <PublishedWinner
                playedWinnerVideoPosition={playedWinnerPosition}
                position={index}
                setPlayedWinnerPosition={setPlayedWinnerPosition}
                winnerName={winner.WinnerName}
                winnerPhoto={winner.WinnerPhoto}
                winnerMobilePhoto={winner.WinnerMobilePhoto}
                winnerVideo={winner.WinnerVideo}
                prize={winner.CarWon}
                dealer={winner.Dealer}
                LinkedCollectionUrl={winner.LinkedCollectionUrl}
                CompetitionRef={winner.CompetitionRef}
              />
            </>
          )}
        </div>
      </VerticalTimelineElement>
    </div>
  );
};

export default TimelineElement;
